"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMetricsTracker = void 0;
exports.getCleanDigitalData = getCleanDigitalData;
exports.getRoot = getRoot;
exports.setupRoot = setupRoot;
var _enums = _interopRequireDefault(require("./types/enums"));
var _helpers = require("./helpers");
var _utils = require("./utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var DEFAULT_USER_ID = '1';
var GLOBAL_KEY = 'sm_metrics_tracker_do_not_touch_this';

/**
 * Creates a new DigitalData object and populates default values for the user
 *
 * @param userId The ID of the current user
 * @returns A DigitalData object populated only with default values
 */
function getCleanDigitalData() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_USER_ID;
  return {
    page: {
      pageInfo: {
        pageId: '',
        attributes: {},
        pathname: ''
      }
    },
    events: [],
    components: [],
    user: {
      ep201: (0, _utils.getCookieValue)('ep201'),
      ep202: (0, _utils.getCookieValue)('ep202'),
      id: userId
    }
  };
}

/**
 * Returns the MetricsTracker root object. If it doesn't exist, creates it.
 *
 * @param glob A reference to the global object that MetricsTrackerRoot will by saved to
 * @returns The MetricsTrackerRoot
 */
function setupRoot(glob) {
  if (!glob[GLOBAL_KEY]) {
    var root = {
      subscribers: [],
      automaticSubscribers: [],
      config: {
        user: {
          id: '',
          isAuthenticated: false
        },
        dataAnalyticsAPIPath: null,
        loggingAPIPath: null,
        country: 'GB',
        legacyWeb: '',
        gtmId: ''
      },
      digitalData: getCleanDigitalData(DEFAULT_USER_ID)
    };
    glob[GLOBAL_KEY] = root;
  }
  return glob[GLOBAL_KEY];
}

/**
 * Returns the global MetricsTrackerRoot object
 *
 * @param glob A reference to the global object on which the MetricsTrackerRoot object exists
 * @returns
 */
function getRoot(glob) {
  if (!glob[GLOBAL_KEY]) {
    throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
  }
  return glob[GLOBAL_KEY];
}

/**
 * Creates a MetricsTrackerType object with common level functionality that is wrapped
 * in scope by the provided global object reference.
 *
 * @param glob A reference to the global namespace that the metrics tracker will be added to
 * @returns A MetricsTrackerType object with it's context bound to the passed in `glob` ref
 */
var createMetricsTracker = function createMetricsTracker(glob) {
  return {
    initialize: function initialize(config) {
      throw new Error('initialize not implemented');
    },
    reset: function reset() {
      throw new Error('reset not implemented');
    },
    update: function update(config) {
      // for some data points within an SPA, the configuration must be
      // updated post initialization
      var root = getRoot(glob);
      root.config = _objectSpread(_objectSpread({}, root.config), config);
      return root;
    },
    /**
     * Convenience method to update parts of the user config that can be decorated post-initialization
     *
     * @param userConfig The updated user configuration
     */
    updateUserConfig: function updateUserConfig(userConfigUpdate) {
      var root = getRoot(glob);
      root.config.user = _objectSpread(_objectSpread({}, root.config.user), userConfigUpdate);
      return root;
    },
    getSubscribers: function getSubscribers() {
      var _getRoot = getRoot(glob),
        subscribers = _getRoot.subscribers;
      return subscribers;
    },
    getAutomaticSubscribers: function getAutomaticSubscribers() {
      var _getRoot2 = getRoot(glob),
        automaticSubscribers = _getRoot2.automaticSubscribers;
      return automaticSubscribers;
    },
    track: function track(event) {
      var _event$data, _event$data2, _event$data2$data;
      var root = getRoot(glob);
      if (root.config.user.id === '') {
        throw new Error('Please initialize MetricsTracker with a userId before tracking events.');
      }
      var maskedEvent = event;

      // mask email addresses
      if (event !== null && event !== void 0 && (_event$data = event.data) !== null && _event$data !== void 0 && _event$data.email) {
        maskedEvent.data.email = (0, _helpers.maskEmail)(event.data.email);
      }
      if (event !== null && event !== void 0 && (_event$data2 = event.data) !== null && _event$data2 !== void 0 && (_event$data2$data = _event$data2.data) !== null && _event$data2$data !== void 0 && _event$data2$data.email) {
        maskedEvent.data.data.email = (0, _helpers.maskEmail)(event.data.data.email);
      }
      if (_enums.default[event.name]) {
        root.digitalData.events.push(event);
        if (_enums.default.COMPONENT_ADD === event.name) {
          root.digitalData.components.push(event.data);
        }
        if (event.name === _enums.default.PAGE_VIEW || event.name === _enums.default.VIRTUAL_PAGE_VIEW) {
          root.digitalData = (0, _helpers.pageViewMutation)(event, root.digitalData);
        }
        root.subscribers.forEach(function (subscriber) {
          subscriber(event, root.config);
        });
      }
    },
    automaticTrack: function automaticTrack(event) {
      var root = getRoot(glob);
      root.automaticSubscribers.forEach(function (subscriber) {
        subscriber(event, root.config);
      });
    },
    addSubscriber: function addSubscriber(subscriber) {
      /**
       * We always want to allow the subscribers to subscribe. If the user
       * did not accept GDPR, we don't fire events; hence, we never violate GDPR.
       * If, however, the user does allow tracking, we don't want to subscribers
       * to re-subscribe.
       */
      var root = getRoot(glob);
      root.subscribers.push(subscriber);
    },
    addAutomaticSubscriber: function addAutomaticSubscriber(subscriber) {
      var root = getRoot(glob);
      root.automaticSubscribers.push(subscriber);
    },
    getConfig: function getConfig() {
      return getRoot(glob).config;
    },
    getDigitalData: function getDigitalData() {
      return getRoot(glob).digitalData;
    }
  };
};
exports.createMetricsTracker = createMetricsTracker;